<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-info">
          <form @submit.prevent class="form-horizontal">
            <div class="box-body">
              <div class="row">
                <div class="col-md-2">
                  <div class="q_avatar" @mouseover="showImageControl(true)" @mouseleave="showImageControl(false)">
                    <img :src="formData.imageUrl == '' ? (formData.picture ? formData.picture : '/static/img/placeholder.png') : '/image/Project/' + formData.imageUrl + '?' + Date.now()" class="img img-responsive" border="1" ref="projectImage">
                    <div class="q_form_image_controls" ref="imageControl">
                      <span class="icon ion-pencil pull-left q_select_file_button" title="Edit" @click="$refs.filePicture.click()"></span>
                      <span class="icon ion-ios-trash-o pull-right q_clear_file_button" title="Clear" @click="clearPicture()"></span>               
                      <div class="q_hidden_input_file ">
                        <input type="file" accept="image/*" ref="filePicture" @change="pictureChange">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-5">                    
                  <div class="form-group">
                    <label for="inputName">Name</label>
                    <h1 style="margin-top:0px;">
                      <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Project Name" v-model="formData.name">
                    </h1>                        
                  </div>                                          
                </div>                    
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General Info</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                      <div class="box no-border">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCompany" class="col-sm-4 control-label">Company</label>
                              <div class="col-sm-8">
                                <select v-model="formData.companyId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                  <option v-for="(row, i) in listCompany" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>
                            </div>                                         
                          </div>
                          <div class="col-md-6"> 
                            <div class="form-group">
                              <label for="inputCity" class="col-sm-4 control-label">City</label>
                              <div class="col-sm-8">
                                <input type="text" class="form-control" id="inputCity" placeholder="" v-model="formData.city" :disabled="viewMode == MODE_VIEW">
                              </div>
                            </div>                                                
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputSAPCode" class="col-sm-4 control-label">SAP Code</label>
                              <div class="col-sm-8">
                                <input type="text" class="form-control" id="inputSAPCode" placeholder="" v-model="formData.sapCode" :disabled="viewMode == MODE_VIEW">
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputTicketClosedTime" class="col-sm-4 control-label">Closed Time of Ticket</label>
                              <div class="col-sm-8">
                                <input type="text" class="form-control timepicker" id="inputTicketClosedTime" placeholder="" v-model="formData.ticketClosedTime" :disabled="viewMode == MODE_VIEW">
                              </div>
                            </div>
                          </div>
                        </div> 
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputBusinessArea" class="col-sm-4 control-label">Business Area </label>
                              <div class="col-sm-8">
                                <input type="text" class="form-control" id="inputBusinessArea" placeholder="" v-model="formData.businessArea" :disabled="viewMode == MODE_VIEW">
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProfitCenter" class="col-sm-4 control-label">Profit Center</label>
                              <div class="col-sm-8">
                                <input type="text" class="form-control" id="inputProfitCenter" placeholder="" v-model="formData.profitCenter" :disabled="viewMode == MODE_VIEW">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputBusinessUnit" class="col-sm-4 control-label">Business Unit</label>
                              <div class="col-sm-8">
                                <select v-model="formData.businessUnit" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                  <option v-for="(row, i) in listBusinessUnit" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <!-- <div class="form-group">
                              <label for="inputProfitCenter" class="col-sm-4 control-label">Profit Center</label>
                              <div class="col-sm-8">
                                <input type="text" class="form-control" id="inputProfitCenter" placeholder="" v-model="formData.profitCenter" :disabled="viewMode == MODE_VIEW">
                              </div>
                            </div> -->
                          </div>
                        </div>                        
                      </div>
                    </div>                       
                  </div>
                </div>
              </div>                                                                     
              <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
              <input type="hidden" class="form-control" id="inputCompanyId" v-model="formData.companyId">
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                <button v-if="viewMode != MODE_VIEW" @click="onCancel()" class="btn btn-warning">Cancel</button>
                <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div> 
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'

export default {
  name: 'ProjectForm',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      formData: {
        id: 0,
        name: '',
        companyName: '',
        companyId: 0,
        city: '',
        imageUrl: '',
        picture: null,
        sapCode: '',
        ticketClosedTime: '',
        businessArea: '',
        profitCenter: '',
        businessUnit: ''
      },
      tabActive: '',
      listCompany: null,
      listBusinessUnit: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.callbackId ? this.$route.params.callbackId : this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback

    this.tabActive = TAB_GENERAL
    this.getDetail()
    this.getCompany()
    this.getBusinessUnit()
  },
  mounted() {
  },
  methods: {
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function() {
        var reader = new FileReader()
        reader.onloadend = function() {
          callback(reader.result)
        }
        reader.readAsDataURL(xhr.response)
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    },
    getDetail() {
      var me = this
      if (this.formData.id !== 0) {
        api
          .request('Account', 'get', '/api/Project/GetDetail?Id=' + this.formData.id, null)
          .then(response => {
            var data = response.data
            this.formData = data.entity
          })
          .then(response => {
            this.getCompany()
          })
          .then(response => {
            this.toDataURL(me.$refs.projectImage.src, function(dataUrl) {
              me.formData.picture = dataUrl
              me.formData.imageUrl = ''
            })
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    showImageControl(show) {
      if (this.viewMode === MODE_VIEW) {
        return
      }
      let el = this.$refs.imageControl
      el.style.opacity = show ? 0.8 : 0
    },
    pictureChange(e) {
      const image = e.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.formData.picture = e.target.result
        this.$refs.projectImage.src = e.target.result
      }
    },
    clearPicture() {
      this.formData.picture = null
      this.formData.imageUrl = ''
    },
    getCompany() {
      api
        .request('Account', 'get', '/api/Company/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listCompany = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getBusinessUnit() {
      api
        .request('Account', 'get', '/api/Project/BusinessUnit', null)
        .then(response => {
          var data = response.data
          this.listBusinessUnit = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.companyId = 0
      this.formData.companyName = ''
      this.formData.imageUrl = ''
      this.formData.picture = null
      this.formData.sapCode = ''
      this.formData.ticketClosedTime = ''
      this.formData.businessArea = ''
      this.formData.profitCenter = ''
      this.formData.businessUnit = ''
      this.getCompany()
    },
    onDisplay() {
      this.viewMode = MODE_VIEW
      this.getDetail()
    },
    onEdit(formData) {
      this.viewMode = MODE_UPDATE
      this.getDetail()
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.$router.push({ name: this.callback })
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        Name: this.formData.name,
        CompanyId: this.formData.companyId,
        ImageBase64String: this.formData.picture,
        City: this.formData.city,
        SAPCode: this.formData.sapCode,
        TicketClosedTime: this.formData.ticketClosedTime,
        BusinessArea: this.formData.businessArea,
        ProfitCenter: this.formData.profitCenter,
        BusinessUnit: this.formData.businessUnit
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Account', 'post', '/api/Project/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ProjectForm.vue?80d00600